import { useMemo, useState } from "react";

// Header-search state + filter shared by the trips tables. Matches the trip id
// and status, plus any `extraFields` (e.g. "reason"). Returns
// [filteredRows, search, setSearch].
//
// Pass a stable (module-level) `extraFields` array so the memo identity holds.
const useTripSearch = (rows, extraFields = []) => {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((row) =>
      [row.id, row.status, ...extraFields.map((field) => row[field])].some((value) =>
        String(value ?? "").toLowerCase().includes(q)
      )
    );
  }, [rows, search, extraFields]);

  return [filtered, search, setSearch];
};

export default useTripSearch;
